  <div class="sidebar-panel" [ngClass]="{'collapsed': isSidebarCollapsed}" id="sidebar" [style.background-color]="backgroundColor">
    <div class="sidebar-background" [style.background-image]="'url(../assets/img/sidebar-' + id + '.jpg)'"></div>
    <app-sidebar [collapsed]="isSidebarCollapsed"></app-sidebar>
  </div>
  <div class="main-panel" id="main-panel" [ngClass]="{'expanded': isSidebarCollapsed}">
    <app-navbar title={{title}} (toggleSidebarEvent)="toggleSidebar()"></app-navbar>
    <router-outlet></router-outlet>
  </div>
 
